import { FC } from 'react';
import { Link, ExternalLink } from '@qga/roo-ui/components';
import { DetailsBooking } from 'types';
import * as track from 'lib/gaTracking/bookingDetailsPageEvents';

interface GetDirectionsLinksWithTrackingProps {
  booking: DetailsBooking;
}

const GetDirectionsLinksWithTracking: FC<GetDirectionsLinksWithTrackingProps> = ({ booking }: GetDirectionsLinksWithTrackingProps) => {
  return (
    <Link as={ExternalLink} onClick={track.getDirectionsLinkSelected} href={booking.links.googleMaps} target="_blank">
      Get directions
    </Link>
  );
};

export default GetDirectionsLinksWithTracking;
